/**
 * normalizeWhitespaceForSave
 *
 * Trims leading/trailing whitespace and collapses multiple spaces
 * into a single space. Use this for any save-time string normalization.
 *
 * @param value - The string to normalize
 * @returns A trimmed string with collapsed internal whitespace
 */
export const normalizeWhitespaceForSave = (value?: string): string => {
  return value
    ?.trim()
    .replace(/\s+/g, " ")
    ?? "";
};